import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import theme from '../../Theming/DefaultTheme';
import CookieConsent from 'react-cookie-consent';
var consentContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    backgroundColor: '#353535',
    color: theme.palette.common.white,
};
var acceptButtonStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.info.extraLight,
    color: theme.palette.info.main,
    padding: 16,
    borderRadius: 8,
    textTransform: 'none',
    width: 130,
    height: 40,
    border: 'solid',
    borderColor: theme.palette.info.main,
    borderWidth: 1,
};
var PageWrapper = function (_a) {
    var children = _a.children;
    return (_jsxs(Box, { children: [children, _jsx(CookieConsent, { location: 'bottom', buttonText: 'I understand', cookieName: 'HuddleMapsCookieConsent', style: consentContainerStyle, buttonStyle: acceptButtonStyle, expires: 150, children: "We use cookies to enhance your experience. By continuing, you consent to our use of cookies." })] }));
};
export default PageWrapper;
